<template>
    <div class="homeinfo mb20">
        <el-row class="fr">
            <el-col :span="16">
                <div class="title_nav fz14">
                    <!-- <div class="left fr ac">
                        <div class="left_item fr ac jc cursor mr30" @click="active = 0">
                            <span :class="{blue:!active}">常见问题</span>
                            <div class="line" v-if="active == 0" />
                        </div>
                        <div class="left_item fr ac jc cursor" @click="active = 1">
                            <span :class="{blue:active}">电子资料</span>
                            <div class="line" v-if="active == 1" />
                        </div>
                    </div>-->
                    <el-tabs v-model="active">
                        <el-tab-pane
                            :label="i.class_name"
                            :name="i.class_id+''"
                            v-for="i in class_list"
                            :key="i.class_id"
                        ></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right fr ac jfe">
                    <input type="text" class="inpust" v-model="title" placeholder="请输入文章名称" />
                    <el-button
                        type="primary"
                        size="small"
                        class="ml20"
                        @click="getInformations(2)"
                    >搜索</el-button>
                </div>
                <div class="pl20 pr20">
                    <info-cell
                        v-for="i in list"
                        :key="i.information_id"
                        :info="i"
                        @insertCollection="insertCollection"
                    />
                </div>
                <!-- 底部导航 -->
                <div class="footer fr ac jc">
                    <el-pagination
                        :hide-on-single-page="true"
                        small
                        layout="prev, pager, next"
                        :total="total"
                        :current-page.sync="page"
                        class="mt30 mb30"
                        background
                    ></el-pagination>
                </div>
            </el-col>
            <el-col :span="8" class="ml20 pt20 pl20 pr20">
                <p>最新发布</p>
                <el-divider />
                <col-cell v-for="i in news_list" :key="i.information_id" :info="i" />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import InfoCell from "@/components/InfoCell";
import col_cell from "./InfoCell";

export default {
    props: {},
    data() {
        return {
            active: "",
            total: 0,
            list: [],
            news_list: [],
            page: 1,
            class_list: [],
            title: ""
        };
    },
    created() {
        this.getInformations(1);
        this.getInformationClasss();
    },
    watch: {
        active(n) {
            this.page = 1;
            this.getInformations();
        },
        page(n) {
            this.getInformations();
        }
    },
    methods: {
        getInformationClasss() {
            this.post("informationInterfaces/v1.0/getInformationClasss").then(
                res => {
                    this.active = res.data[0].class_id + "";
                    this.class_list = res.data;
                }
            );
        },
        // 获取常见问题
        getInformations(news) {
            let obj = {};
            obj.page = this.page;
            obj.class_id = this.active;
            if (news == 1) {
                obj.is_new = 1;
                obj.class_id = "";
            } else if (news == 2) {
                obj.information_title = this.title;
                obj.class_id = "";
            }
            this.post("/informationInterfaces/v1.0/getInformations", obj).then(
                res => {
                    if (res.status == "ok") {
                        this.total = res.total;
                        if (news != 1) {
                            this.list = res.data;
                        } else {
                            this.news_list = res.data;
                        }
                    }
                }
            );
        },
        insertCollection(id) {
            this.post("collectionInterfaces/v1.0/insertCollection", {
                collection_id: id,
                collection_type: 2
            }).then(res => {
                this.getInformations();
            });
        }
    },
    components: { "info-cell": InfoCell, "col-cell": col_cell }
};
</script>

<style scoped lang="scss">
.homeinfo {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    .el-col {
        background-color: #fff;
        .title_nav {
            width: 100%;
            height: 60px;
            padding: 0 20px;
            .left {
                width: 35%;
                height: 100%;
                .left_item {
                    width: 30%;
                    height: 100%;
                    position: relative;
                    .line {
                        width: 100%;
                        position: absolute;
                        left: 0;
                        bottom: 10%;
                        right: 0;
                        margin: auto;
                        height: 2px;
                        background-color: #458ef6;
                    }
                }
            }
        }
        .right {
            padding-right: 20px;
            .inpust {
                width: 300px;
                height: 30px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(203, 203, 203, 1);
                padding-left: 10px;
                font-size: 12px;
            }
        }
        .footer {
            width: 100%;
            .el-pagination {
                .el-pager {
                    .number {
                        border: 1px solid #979797;
                    }
                    .active {
                        border: none !important;
                    }
                }
                .btn-prev,
                .btn-next {
                    width: 60px;
                    border: 1px solid rgba(151, 151, 151, 1);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeInfo/index.vue